import React, { useState, useEffect } from 'react';
import FormNews from './FormNews';

const ListNews = () => {
    const [blogs, setBlogs] = useState([]);
    // const [Form, setForm] = useState(false);

    // Simulating an API call to fetch blog data
    useEffect(() => {
        const fetchBlogs = async () => {
            // Example static data. Replace this with a real API call if needed
            const blogData = [
                { id: 1, title: 'React Basics', author: 'John Doe', date: '2024-10-10' },
                { id: 2, title: 'Understanding React Hooks', author: 'Jane Doe', date: '2024-10-12' },
                { id: 3, title: 'Advanced React Patterns', author: 'Mike Ross', date: '2024-10-15' }
            ];

            // Simulate a delay (as if fetching from an API)
            setTimeout(() => {
                setBlogs(blogData);
            }, 1000);
        };

        fetchBlogs();
    }, []);

    return (
        <>
            <FormNews />
            <section className="p-relative">
                <div className="container mt-4 mb-4">
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <h2 className="text-left mb-4">
                                List of News
                                <div style={{ float: 'right' }}>
                                    +
                                </div>
                                <div style={{ clear: 'both' }}></div>
                            </h2>
                            {blogs.length > 0 ? (
                                <ul className="list-group">
                                    {blogs.map((blog) => (
                                        <li key={blog.id} className="list-group-item">
                                            <h5>{blog.title}</h5>
                                            <p>By {blog.author} on {new Date(blog.date).toLocaleDateString()}</p>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p className="text-center">Loading blogs...</p>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ListNews;
